<div
  *ngIf="image && primaryLabel"
  class="avatar-container d-flex flex-column align-items-center position-relative w-100 h-100 cursor-pointer"
  (click)="avatarClicked()"
  floAnalytics
  eventName="Avatar Clicked"
  [elementName]="segmentName"
  [analyticsProperties]="analytics">
  <span *ngIf="removable && selected"
        class="avatar-container__minus-button position-absolute color-ignite svg-icon-md" data-test="removable-icon">
    <flo-svg-icon icon="minus-filled" width="1.375em"></flo-svg-icon>
  </span>
  <div
    class="position-absolute avatar-container__border rounded-circle"
    data-test="avatar-container__border"
    [ngClass]="{ 'avatar-container__border-selected': selected }"></div>
  <div
    class="avatar-container__image-container w-100 d-flex align-items-center justify-content-center mb-2 mb-md-3 overflow-hidden position-relative rounded-circle"
    data-test="avatar-image-container">
    <ng-container *ngIf="image">
      <img
        [src]="image | floImage: 400 | async"
        alt="{{ primaryLabel }}"
        class="avatar-container__img h-100 no-skeleton position-absolute"
        data-test="avatar-image">
    </ng-container>
  </div>
  <h2
    *ngIf="primaryLabel"
    class="avatar-container__primary-text mb-0 pt-1 pt-md-0 headline w-100 text-truncate text-center"
    data-test="primary-text"
    [ngClass]="{ 'avatar-container__primary-text-selected': selected, 'text-wrap text-line-clamp-2': !secondaryLabel }"
  >{{ primaryLabel}}</h2>
  <h3
    *ngIf="secondaryLabel"
    class="avatar-container__secondary-text footnote w-100 text-truncate text-center"
    data-test="secondary-text"
    [ngClass]="{ 'avatar-container__secondary-text-selected': selected }"
  >{{ secondaryLabel}}</h3>
</div>

